import dayjs from "dayjs";
import { KYDEventBlockData } from "interfaces/KYDCampaign";
import { KYDGender } from "interfaces/KYDUser";

export const genderToText = (gender: KYDGender | "any") => {
  switch (gender) {
    case "male":
      return "Male";
    case "female":
      return "Female";
    case "any":
      return "Any";
    case "prefernottosay":
      return "-";
  }
};

export const replaceCampaignVariables = (
  text: string,
  eventData: KYDEventBlockData
) => {
  const availableVariables = [
    {
      dynamicKey: "{{start_at}}",
      objectKey: "start_at",
      format: (value: string) => dayjs(value).format("MMMM D, YYYY"),
    },
    {
      dynamicKey: "{{event_name}}",
      objectKey: "name",
    },
    {
      dynamicKey: "{{end_at}}",
      objectKey: "end_at",
      format: (value: string) => dayjs(value).format("MMMM D, YYYY"),
    },
    {
      dynamicKey: "{{link}}",
      objectKey: "link",
    },
    {
      dynamicKey: "{{venue}}",
      objectKey: "venue",
    },
  ];

  return text?.replace(/{{(.*?)}}/g, (match: string) => {
    const variable = availableVariables.find((v) => v.dynamicKey === match);
    if (variable) {
      const value = variable.objectKey.includes(".")
        ? variable.objectKey.split(".").reduce((obj, key) => obj?.[key], eventData.event)
        : eventData.event[variable.objectKey];

      if (variable.format) {
        return variable.format(value as string);
      }

      return value || match;
    }
  });
};
